import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {OrgInviteUserModalComponent} from "./components/org-invite-user-modal/org-invite-user-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {OrganisationService} from "../../services/organisation/organisation.service";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {OrgUserFilterModalComponent} from "./components/org-user-filter-modal/org-user-filter-modal.component";
import {OrgUsersService} from "./services/org-users.service";
import * as moment from "moment/moment";
import { NewInviteUserComponent } from './components/new-invite-user/new-invite-user.component';
import { UnsavedChangesComponent } from './components/unsaved-changes/unsaved-changes.component';
import { ConstantsService } from 'src/app/services/constants/constants.service';


@Component({
  selector: 'app-org-users',
  templateUrl: './org-users.component.pug',
  styleUrls: ['./org-users.component.scss'],
  standalone: false
})
export class OrgUsersComponent implements OnInit, OnChanges {

  @Input() org: any;
  @Input() managePermissionsUser: any;
  @ViewChild('filterBtn', { read: ElementRef }) filterBtn!: ElementRef;
  selectedTab = $localize`Users`;
  invited = false;
  searchQuery = {type: '', search: ''};
  updatedSearch = '';
  disableButton = true;
  loadOrg = false;
  invitedUserCount!: number;
  total = 5;
  rowsPerView = 20;
  currentPage = 1;
  sortString = 'last_access';
  sortOrder = 'desc';
  displayAlert = false;
  filterOptions = [{'label': $localize`Owner`, 'value': 'owner'}, {
    'label': $localize`Admin`,
    'value': 'admin'
  }, {'label': $localize`Member`, 'value': 'member'}, {
    'label': $localize`Member (restricted)`,
    'value': 'member (restricted)'
  }, {'label': $localize`Xref Support`, 'value': 'support'}];
  filters: any[] = [];
  newFilters: any[] = [];
  searchOptionsUser = [
        {label: $localize`Name`, value: 'name', hint: $localize`First or last name`},
        {label: $localize`Email`, value: "email", hint: $localize`Email address`}
      ];
  searchOptionsInvitation = [
        {label: $localize`Email`, value: "email", hint: $localize`Email address`}
      ];
  tabSelection = {
    usersSelected: $localize`Users`,
    invitationsSelected: $localize`Invitations`
  }
  private bsModalRef: any;
  searchOptions = ['First name', 'Last name', 'Email'];
  filterButtonTooltip: any;

  sharedData: any;
  orgUsers: any;
  model: any;
  reRenderCheck: boolean = false;

  constructor(private modalService: BsModalService,
              private organisationService: OrganisationService,
              private alertList: AlertBannerService,
              private permissions: PermissionsService,
              public orgUserService: OrgUsersService
  ) {

  }

  ngOnInit(): void {
    const success = () => {
      if (this.permissions.hasUserOrgPermission('can_manage_reference_invitees_and_users') ||
        this.permissions.hasUserOrgPermission('can_manage_exit_invitees_and_users') ||
        this.permissions.hasUserOrgPermission('can_manage_pulse_invitees_and_users') ||
        this.permissions.hasUserOrgPermission('can_manage_backgroundcheck_invitees_and_users')) {
        this.loadOrg = true;
        this.disableButton = false;
      } else {
        this.loadOrg = true;
      }

    }
    const error = () => {
      console.log(error);
      this.loadOrg = false;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    }

    this.permissions.accManagementPermissionSubject.subscribe((hasDataLoaded) => {
      if (hasDataLoaded) {
        success();
      } else {
        error();
      }
    });
    if (this.managePermissionsUser) {
      this.searchQuery = {
        search: this.managePermissionsUser,
        type: 'email'
      };
    }
  }



  ngOnChanges(changes: SimpleChanges) {
    if (this.permissions.hasUserOrgPermission('can_manage_reference_invitees_and_users')) {
      this.disableButton = false;
    }

  }

  changeView(value: any) {
    this.selectedTab = value.view;
    this.updatedSearch = value.searchData;
  }

  switchTab(value: any) {
    this.selectedTab = value.view;
    if((this.selectedTab === 'Invitations' && this.searchQuery?.type === 'name') || !value.type) {
      this.reRenderCheck = true;
      setTimeout(() => {
        this.reRenderCheck = false;
      }, 0);
    }
    this.searchQuery = {
      ...this.searchQuery,
      search: value.searchData ? value.searchData : '',
      type: value.type ? value.type : ''
    };
    this.updatedSearch = value.searchData ? value.searchData : '';
    this.updateSharedData();
  }

  showInviteUserModal() {
    this.loadOrg = false;
      this.organisationService
      .getTeams(0, 20, 'name', 'default team')
      .subscribe((data: any) => {
        this.loadOrg = true;
        this.openInviteUserModal({
          selectedTeams: data.data.teams,
          memberOptions: this.getMembersOptions()
        })
      }, (error) => {
        this.loadOrg = true
      })

  }

  getMembersOptions() {
    const loggedInUserRole:any = this.permissions.role;
    return ConstantsService.getMemberOptions().map((member) => {
      if(loggedInUserRole.role === 'member' && !this.permissions.getUsersControlPermissionName(member.name)) {
        return {...member, disabled: true}
      }
      return member;
    })
  }

  openInviteUserModal(initialState) {
    this.model = this.modalService.show(
      NewInviteUserComponent,
      {
        class: 'modal-dialog-centered  m-popup',

        initialState}
    );
    this.model.content.saveClick.subscribe((data) => {
      const content = this.model.content;
      if(data == 'success') {
        const payload = {
          email: content.email,
          teams: content.selectedTeams.map((teams:any) => (teams.global_team_uuid)),
          questionnaires: content.selectedSurveys.map((survey) => survey.questionnaire.id),
          role: {
            role: content.selectedRole.toLowerCase(),
            products :content.memberOptions.reduce((acc, member) => {
              acc[member.name] = member.key;
              return acc;
            }, {})
          }
        }
        this.addUser(payload)
      } else if (data?.error) {
        this.model.content.isValid = false;
          content.errors = [{
            enabled: true,
            msg: data.error,
            name: 'wrongPattern',
          }];
      }
    })
    this.model.onHide.subscribe((data) => {
      this.loadOrg = true;
      const content = this.model.content;
      const emptyInitialData = content.selectedRole === '' && content.selectedTeams.length === 1 && content.selectedTeams[0].name === 'Default team'
        && content.selectedSurveys.length === 0 && content.email === '';
      if (content.message != 'force-close' && this.alertList.alerts.length < 1 && !emptyInitialData) {
        this.openUnsavedChangesModal(this.model.content);
      }
    })
  }

  openUnsavedChangesModal(content) {
    const unSavedModel:any = this.modalService.show(UnsavedChangesComponent,
      Object.assign({},{class:'modal-dialog-centered s-popup'})
    );
    unSavedModel.onHide.subscribe((data) => {
      if(unSavedModel.content.message === 'confirm'){
        const initialState = {
          selectedTeams: content.selectedTeams,
          selectedSurveys: content.selectedSurveys,
          memberOptions: content.memberOptions,
          cloneData: content.cloneData,
          selectedRole: content.selectedRole,
          email: content.email
        };
        this.openInviteUserModal(initialState);
      }
    })
  }

  addUser(payload: any) {
    this.loadOrg = false;
    this.organisationService.addUser(payload).subscribe((data) => {
      this.model.hide()
      this.loadOrg = true;
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! An invitation has been sent to ` + payload['email'],
        keepOnRouteChange: true
      }]);
    }, (error) => {
      if (error?.error?.data?.errors?.non_field_errors === 'Invalid email' || error?.error?.data?.errors?.non_field_errors === 'Enter a valid email address.') {
        this.model.content.saveClick.emit({ error: $localize`A valid business email address is required, please review and edit to proceed.` });
        return
      } else if(error?.error?.data?.errors?.user === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`A user with email address ${payload.email} already exists.` });
        return
      } else if (error?.error?.data?.errors?.user_email === 'duplicate') {
        this.model.content.saveClick.emit({ error: $localize`An invitation has already been sent to ${payload.email}. Resend invitation.` });
        return;
      } else if (error?.error?.data?.errors?.operation === 'not_permitted' &&
        (payload?.role?.role == 'owner' || payload?.role?.role == 'member') &&
        payload.email.includes('@xref.com')) {
        this.model.content.saveClick.emit({ error: $localize`A valid business email address is required, please review and edit to proceed.` });
        return;
      } else if (error?.error?.data?.errors?.operation === 'not_permitted') {
        this.model.content.saveClick.emit({ error: $localize`Xref support role can only be assigned to Xref staff.`});
        return;
      }
      this.loadOrg = true;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  resetInvited(invited) {
    this.invited = false;
  }

  clearSearchResult(event) {
    this.searchQuery = {
      ...this.searchQuery,
      search: '',
      type: event.type.toLowerCase()
    };
    this.updatedSearch = '';
    this.updateSharedData();
  }

  addInviteUser(data) {
    this.organisationService.setOrganisationInvitedUser(data['payload']).subscribe(res => {
      this.invited = true;
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! An invitation has been sent to ${data['payload']['email']}`,
        keepOnRouteChange: true
      }]);
      this.bsModalRef.hide();
      }, error => {
        let errorMap = new Map([
          ["user", new Map<any, any>([["duplicate", {
            'message': $localize`A user with email address ${data['payload']['email']} already exists.`,
            'type': 'danger'
          }
          ]])],
          ["user_email", new Map<any, any>([["duplicate", {
            'message': $localize`An invitation has already been sent to ${data['payload']['email']} Resend invitation`,
            'type': 'resendInvite'

          }]])],
          ["email", new Map<any, any>([["invalid", {
            'message': $localize`Only business email addresses are accepted.`,
            'type': 'danger'
          }]])],
          ["operation", new Map<any, any>([["not_permitted", {
            'message': $localize`Xref support role can only be assigned to Xref staff.`,
            'type': 'danger'
          }]])]
        ]);
        let messages: Array<any> = [];
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = errorMap.has(key) ? errorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          messages.push({
            'type': message['type'],
            'message': message['message']
          });
        }
        this.bsModalRef.content.setMessages(messages);
      })
    }

  translateForDisplay() {

    for (let orgUser of this.orgUsers) {
      orgUser["rolesToolTipData"] = JSON.stringify(orgUser.roles)

      if (orgUser["invited"] !== null) {
        orgUser['invited'] = moment.unix(orgUser['invited']).format('MMM DD, YYYY')
      }
      if (orgUser['last_access'] !== null) {
        orgUser['last_access'] = moment.unix(orgUser['last_access']).format('MMM DD, YYYY')
      }
    }
  }

  onSearchEvent($event: any) {
    const {type, search} = $event;
    if ((type === 'Name' || type === 'Email') && search === "") {
      return;
    }

    this.searchQuery = {
      ...this.searchQuery,
      search,
      type: type.toLowerCase()
    };

    this.updatedSearch = search;
    this.updateSharedData();
  }

  updateSharedData() {
    const data = {
      searchedData: this.updatedSearch,
      searchQuery: this.searchQuery,
      rowsPerView: this.rowsPerView,
      currentPage: this.currentPage,
      sortString: this.sortString,
      sortOrder: this.sortOrder,
      filters: this.filters
    };
    this.orgUserService.updateData(data);
  }


  openFiltersModal() {
    if(!this.filters.length) {
      this.orgUserService.updateData({});
    }
    const initialState = {
      org: this.org,
      ...this.sharedData
    };
    this.bsModalRef = this.modalService.show(OrgUserFilterModalComponent, {
      class: 'm-popup modal-dialog modal-dialog-centered',
      initialState
    });

    this.bsModalRef.onHide.subscribe(() => {
      this.filterBtn?.nativeElement?.childNodes[0]?.blur();
    });

    this.bsModalRef.content?.applyFilter.subscribe(() => {
      this.newFilters = (this.bsModalRef.content as OrgUserFilterModalComponent).filters;
      if(JSON.stringify(this.newFilters) !== JSON.stringify(this.filters) ){
        this.filters = (this.bsModalRef.content as OrgUserFilterModalComponent).filters;
      }
    });
  }

  showLoader($event: any) {
    this.loadOrg = $event;
  }

}
